import React, { useState, useEffect, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import { useTranslation } from "react-i18next";
import '../styles/MainPage.css';
import '../components/LanguageChange.jsx';
import LanguageChange from "../components/LanguageChange.jsx";

function MainPage() {
    const navigate = useNavigate()

    const { t } = useTranslation()
    const { i18n } = useTranslation()

    return (
        <>
        <div className={'main-page-container'}>
            <div className={'main-page-wrapper'}>

                <div className={'main-page-background'}>
                    <div className={'main-page-bg-sun'}>
                        <img src="/assets/img/main/bg-sun.svg" alt="" />
                    </div>
                    <div className={'main-page-bg-cloud-1'}>
                        <img src="/assets/img/main/cloud1.svg" alt="" />
                    </div>
                    <div className={'main-page-bg-cloud-2'}>
                        <img src="/assets/img/main/cloud2.svg" alt="" />
                    </div>
                    <div className={"main-page-big-plane"}>
                        <img src="/assets/img/main/bigplane.svg" alt="" />
                    </div>
                    <div className={"main-page-phone-plane"}>
                        <img src="/assets/img/main/phone-plane.svg" alt="" />
                    </div>
                    <div className={'aviator-plane-clouds'}>
                        <img src="/assets/img/main/aviator-clouds.svg" alt="" />
                    </div>
                    <div className={'mp-compass'}>
                        <img src="/assets/img/main/compass.png" alt="" />
                    </div>
                    <div className={'mp-reverse-compass'}>
                        <img src="/assets/img/main/reverse-compass.png" alt="" />
                    </div>
                    <div className={'mp-red-compass'}>
                        <img src="/assets/img/main/av-compass.png" alt="" />
                    </div>
                </div>

                <div className={'z-index-2'}>
                <div className={'main-page-header-wrapper'}>
                    <div className={'main-page-logo'}>
                        <img src="/assets/img/main/Logo.png" alt="" />
                    </div>
                    <div className={'main-page-auth-wrapper'}>
                        {/* <div className={'language-change-wrapper'}>
                            <div className={'language-change-container'}>
                                <div style={{"color": "white", "fontWeight": "600"}}>RU</div>
                                <img src="/assets/img/main/down-arrow-56.svg" alt="" />
                            </div>
                        </div> */}
                        <div style={{"display": "flex"}}>
                        <div className={'main-page-login-wrapper'}>
                            <button className={'login-button'} onClick={() => {
                                navigate('/login')
                            }}>
                                <img src="/assets/img/main/login.svg" alt="" />
                                <span>Login</span>
                            </button>
                        </div>
                        <div className={'main-page-registration-wrapper'}>
                            <button className={'registration-button'} onClick={() => {
                                navigate('/registration')
                            }}>
                                <img src="/assets/img/main/circle-plus.svg" alt="" />
                                <span>Registration</span>
                            </button>
                        </div>
                        </div>
                        {/* <LanguageChange /> */}
                    </div>
                </div>

                <div className={"main-page-content-wrapper"}>
                    <div className={'main-page-content-title'}>
                        <section className={"d-flex jc-center flex-direction-column align-items-center"}>
                            <p className={"text-color-white font-size-35 font-bold"}>Your bet, your flight! Take control and win big</p>
                            <p className={'text-color-red font-size-42 font-bold'}>With AviatorWinn</p>
                        </section>
                    </div>
                    <div className={'main-page-content-h2 h2-mobile'}>
                    <section className={'font-size-12'}>
                            <p className={'text-color-white'}>
                            Experience incredible emotions in an exciting game where every decision can be fateful!
                            Take off on board the plane and watch the growing multiplier 
                            but be careful - the higher you fly, the greater the risk of a crash.
                            </p>
                        </section>
                    </div>
                    <div className={'main-page-content-h2'}>
                    <section className={'font-size-16 ready-aviatorwinn-section font-bold'}>
                            <p className={'text-color-white'}>
                            <span className={'text-color-red'}>Ready</span> to try your luck and soar to huge winnings? 
                            </p>
                            <p className={'text-color-white'}><span className={'text-color-red'}>AviatorWinn</span> is your chance to prove that you are a master of risk!</p>
                        </section>
                    </div>
                    <div className={'main-page-content-h2'}>
                        <button className={'main-page-play-button'} onClick={() => {
                                navigate('/registration')
                            }}>
                            <span>PLAY AVIATOR</span>
                        </button>
                    </div>
                    <div className={'main-page-content-h3'}>
                        <h3 className={'text-color-white font-size-22'}>What is <span className={'text-color-red'}>Aviator</span>?</h3>
                        <p className={'text-color-crem font-size-14 width-650 padding-top-20'}>Aviator is an exciting crash game that combines strategy, risk, and real-time decision-making. 
                            The game features a plane that takes off and increases its multiplier as it ascends. 
                            The goal is to cash out your bet before the plane crashes! The longer you wait, 
                            the higher the potential winnings—but if you wait too long, you risk losing everything.</p>
                        <p className={'text-color-crem font-size-14 width-650 padding-top-20'}>
                            With its simple yet thrilling mechanics, Aviator has gained popularity among casino 
                            enthusiasts and betting fans worldwide. The game offers an engaging experience 
                            with live multiplayer action, chat features, and real-time betting statistics.
                        </p>
                        <ul className={'main-page-key-features-list text-color-crem padding-top-20'}>
                            <li className={'main-page-key-features'}>💰 Key Features</li>
                            <li className={'key-features-item'}>✔️ Fast-paced, high-adrenaline gameplay</li>
                            <li className={'key-features-item'}>✔️ Real-time multiplier increases</li>
                            <li className={'key-features-item'}>✔️ Cash out at the right moment for maximum profit</li>
                            <li className={'key-features-item'}>✔️ Play with other users and track their bets</li>
                            <li className={'key-features-item'}>✔️ Exclusive bonuses for new players</li>
                        </ul>
                        <p className={'text-color-crem font-size-16 width-650 padding-top-20'}>Ready to take off? Place your bet and see how high you can fly before the crash! 🚀🔥</p>
                    </div>

                    <div className={'main-page-how-to-play'}>
                        <div className={'main-page-content-h4'}>
                            <h2 className={'text-color-white text-align-center'}>HOW TO <span className={'text-color-red'}>PLAY</span>?</h2>
                            <p className={'padding-top-20 text-color-crem font-size-18 padding-left-110'}>Aviator is as easy to play as 1-2-3</p>
                            <div className={'main-page-play-steps'}>
                                <div className={'main-page-play-steps-item'}>
                                    <p className={'font-size-28 font-bold text-color-white'}>1</p>
                                    <img src="/assets/img/main/rules-step-1.png" alt="" />
                                    <div className={'main-page-steps-footer'}>
                                        <img className={'cash-pic-steps'} src="/assets/img/main/cash-pic-steps.png" alt="" />
                                        <p className={'text-color-white font-bold pr-5'}><span className={'text-color-red'}>BET</span>before take-off</p>
                                    </div>
                                </div>
                                <div className={'main-page-play-steps-item'}>
                                <p className={'font-size-28 font-bold text-color-white'}>2</p>
                                    <img src="/assets/img/main/rules-step-02.png" alt="" />
                                    <div className={'main-page-steps-footer'}>
                                        <img className={'cash-pic-steps'} src="/assets/img/main/cash-pic-steps.png" alt="" />
                                        <p className={'text-color-white font-bold pr-5'}><span className={'text-color-red'}>WATCH</span>as your Lucky Plane takes
                                            off and your winnings increase</p>
                                    </div>
                                </div>
                                <div className={'main-page-play-steps-item'}>
                                <p className={'font-size-28 font-bold text-color-white'}>3</p>
                                    <img src="/assets/img/main/rules-step-03.png" alt="" />
                                    <div className={'main-page-steps-footer'}>
                                        <img className={'cash-pic-steps'} src="/assets/img/main/cash-pic-steps.png" alt="" />
                                        <p className={'text-color-white font-bold pr-5'}><span className={'text-color-red'}>CASH OUT</span>before plane disappears
                                            and win X times more!</p>
                                    </div>
                                </div>
                                
                            </div>
                            <div className={'main-page-steps-under-text'}>
                                <p className={'text-color-crem font-size-14'}> But remember, if you did not have time to Cash Out before the Lucky Plane flies away, 
                                    your bet will be lost. Aviator is pure excitement! Risk and win. 
                                    It’s all in your hands!
                                </p>
                            </div>
                            <div className={'main-page-how-to-win'}>
                                <img className={'mp-how-to-win-img'} src="/assets/img/main/how-to-win.png" alt="" />
                                <div className={'mp-how-to-win-wrapper text-color-crem'}>
                                    <h3 className={'text-color-white'}>How to <span className={'text-color-red'}>Win</span>?</h3>
                                    <p className={'mp-how-to-win-wrapper-p'}>Want to maximize your winnings in Aviator? Follow these expert tips to increase your chances of success!</p>
                                    <p className={'mp-how-to-win-wrapper-p'}>🔥 1. Start with Smart Bets</p>
                                    <p>Don't go all in on a single round—manage your bankroll wisely and play strategically.</p>
                                    <p className={'mp-how-to-win-wrapper-p'}>⚡ 2. Use Auto Cash-Out
                                    </p>
                                    <p>Set an automatic cash-out at a reasonable multiplier to secure consistent profits.</p>
                                    <p className={'mp-how-to-win-wrapper-p'}>📊 3. Analyze Previous Rounds
                                    </p>
                                    <p>Check past multipliers to identify patterns and adjust your strategy accordingly.</p>
                                    <p className={'mp-how-to-win-wrapper-p'}>🎯 4. Play with Dual Bets
                                    </p>
                                    <p>Increase your winning potential by placing two bets at once with different strategies.</p>
                                    <p className={'mp-how-to-win-wrapper-p'}>💰 5. Stay Calm & Play Smart
                                    </p>
                                    <p>Don't let emotions take over—stick to your strategy and cash out at the right moment.</p>
                                    <p className={'mp-how-to-win-wrapper-p'}>🚀 Win Big in Aviator Today! Play smart, take calculated risks, and claim your rewards! 🎉</p>
                                </div>
                            </div>
                            <div className={'mp-footer-auth'}>
                            <div className={'main-page-auth-wrapper'}>
                                <div className={'main-page-login-wrapper'}>
                                <button className={'login-button'} onClick={() => {
                                navigate('/login')
                            }}>
                                    <img src="/assets/img/main/login.svg" alt="" />
                                    <span>Log In</span>
                                </button>
                                </div>
                                <div className={'main-page-registration-wrapper'}>
                                <button className={'registration-button'} onClick={() => {
                                navigate('/registration')
                            }}>
                                    <img src="/assets/img/main/circle-plus.svg" alt="" />
                                    <span>Registration</span>
                                </button>
                                </div>
                    </div>
                            </div>
                        </div>
                        
                    </div>
                    

                </div>
                
                </div>
            </div>
        </div>


        </>
    )
}

export default MainPage;